import { render, staticRenderFns } from "./FField.vue?vue&type=template&id=83ddcdbc"
import script from "./FField.vue?vue&type=script&lang=js"
export * from "./FField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Quotations/FField.vue
// module id = 168
// module chunks = 31